module.exports = __webpack_public_path__ + "static/offer-podologia-image-1-f12671a4bab0b698057928e3dabfd4b3.png";